import { RefObject, useEffect } from "react";

/**
 * Closes a floating element (menu, popover, etc.) when a pointerdown fires
 * outside of it. Intended for use alongside MUI Menu/Popover components whose
 * Modal root has `pointer-events: none`, which disables the built-in backdrop
 * click-to-close.
 */
export function useCloseOnOutsidePointerDown(
    isOpen: boolean,
    elementRef: RefObject<HTMLElement | null>,
    onClose: () => void,
): void {
    useEffect(() => {
        if (!isOpen) {
            return;
        }

        const handlePointerDown = (event: PointerEvent) => {
            if (elementRef.current && !elementRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        document.addEventListener("pointerdown", handlePointerDown, true);
        return () => {
            document.removeEventListener("pointerdown", handlePointerDown, true);
        };
    }, [isOpen, elementRef, onClose]);
}
